<template>
    <div class="uploader" @click="select()" title="Click to upload">
        <input type="file" class="d-none" ref="input" @change="changed">
        <div class="upload-progress" v-if="uploader.status.uploading">
            <slot name="progress">
                <lottie-animation
                    class="animation"
                    :loop="true"
                    :animation-data="require('@/Animations/Canvas2/uploading.json')" />
            </slot>
        </div>
        <slot v-else>
            Click to upload files
        </slot>
    </div>
</template>

<script>
import {LottieAnimation} from "lottie-web-vue";
import API from "@/API";

export default {
    name: "SleekFileUploader",
    components: {LottieAnimation},
    emits: ['update:modelValue', 'change', 'uploadstart', 'uploadend'],

    props: {
        modelValue: {
            type: Object,
            default: null,
        },

        path: {
            type: String,
            default: 'public-uploads',
        },
    },

    data(){
        return {
            uploader: {
                file: null,
                dragging: false,
                status: {
                    uploading: false,
                    progress: 0,
                }
            },
        }
    },

    methods: {

        select(){
            if( this.uploader.status.uploading === true ) return;
            this.$refs.input.click();
        },

        changed(){
            if( this.$refs.input.files.length ){
                // console.log({FILES: this.$refs.input.files});
                this.upload(this.$refs.input.files);
            }
        },

        async upload(files){

            if( files && files.length ){

                this.uploader.status.uploading = true;
                this.$emit('uploadstart');

                try {

                    const uploaded = await API.uploads.store(files[0], this.path, {
                        onUploadProgress: (ev) => {
                            const total = ev.lengthComputable ? ev.total : ev.target.getResponseHeader('content-length') || ev.target.getResponseHeader('x-decompressed-content-length');
                            if (total !== null) {
                                this.uploader.status.uploading = true;
                                this.uploader.status.progress = Math.round((ev.loaded * 100) / total);
                            }
                        }
                    });

                    this.uploader.file = uploaded?.file;
                    this.$refs.input.value = null;

                    this.$emit('update:modelValue', this.uploader.file);
                    this.$emit('change', this.uploader.file);

                }catch (e){}

                this.uploader.status.uploading = false;
                this.uploader.status.progress = 0;
                this.$emit('uploadend');
            }
        },
    }
}
</script>

<style lang="scss" scoped>
.uploader{
    cursor: pointer;
    transition: background .3s;
    padding: .5rem;
    border-radius: .3rem;

    &:hover{
        background: rgba(black, .3);
    }
}
.animation{
    display: block;
    width: 120px;
    height: auto;
    margin: auto;
}
</style>
